import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

const CircularLoader = ({ size, noWrapper }) => {
  return (
    <Grid
      container
      alignItems='center'
      justifyContent='center'
      sx={!noWrapper ? { height: 'calc(100vh - 212px)' } : undefined}>
      <Grid item>
        <CircularProgress size={size} sx={{ color: '#12ccc0' }} />
      </Grid>
    </Grid>
  );
};

CircularLoader.propTypes = {
  size: PropTypes.number,
  noWrapper: PropTypes.bool,
};

CircularLoader.defaultProps = {
  size: 60,
  noWrapper: false,
};

export default CircularLoader;
